// extracted by mini-css-extract-plugin
export default {"drawer-form":"drawer-form_drawer-form__7Cf4Y","deal_form_top":"drawer-form_deal_form_top__pLb7H","new_warehouse_box":"drawer-form_new_warehouse_box__t1ard"};